import { connect } from 'react-redux';

import CustomCollectionSecondaryNavigation from 'components/CustomCollectionSecondaryNavigation';
import * as actions from 'state/actions';

const mapStateToProps = (state, ownProps) => {
  const { secondaryNavigationOptions } = ownProps;

  const [tabs, linkUrls] = secondaryNavigationOptions.reduce(
    ([labelAcc, linkAcc], { label, linkUrl }) => {
      labelAcc.push(label);
      linkAcc.push(linkUrl);
      return [labelAcc, linkAcc];
    },
    [[], []]
  );

  const activeTabIndex = secondaryNavigationOptions.findIndex(option => option.isActive);

  return {
    tabs,
    linkUrls,
    activeTabIndex,
  };
};

const mapDispatchToProps = dispatch => ({
  trackNavigation: url => {
    dispatch(actions.trackSecondaryNavigationNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomCollectionSecondaryNavigation);
